/* ==========================================================
   APS — Cart Cost Summary (v3.0, MOQ verwijderd)
   + Recommendation prices: hoofdprijs = met korting
   --------------------------------------------------------------
   Oorspronkelijk bevatte dit script een "minimum 7 meals" MOQ-check
   voor SportMeals. Voor AirplantShop is dat concept vervallen — de
   checkout-knop blijft altijd enabled en toont het display-totaal
   (subtotaal + bezorgkosten).
   ========================================================== */

(() => {

  const $$ = (sel, ctx) =>
    Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  const $ = (sel, ctx) => (ctx || document).querySelector(sel);

  /* ---------- Helpers ---------- */

function fetchCart() {
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  const url = `${root}cart.js`;

  return fetch(url, {
    credentials: 'same-origin',
    cache: 'no-store',
    headers: {
      'Accept': 'application/json',
      'Cache-Control': 'no-cache'
    }
  })
    .then(async (r) => {
      const ct = (r.headers.get('content-type') || '').toLowerCase();

      if (!r.ok) {
        const text = await r.text().catch(() => '');
        throw new Error(`cart.js HTTP ${r.status}. content-type=${ct}. body-start=${text.slice(0, 80)}`);
      }

      // ✅ Shopify kan text/javascript teruggeven, maar de body is alsnog JSON.
      // Probeer altijd eerst r.json(); als dat faalt, probeer text + JSON.parse.
      try {
        return await r.json();
      } catch (e) {
        const text = await r.text().catch(() => '');
        try {
          return JSON.parse(text);
        } catch (_) {
          throw new Error(`cart.js parse error. content-type=${ct}. body-start=${text.slice(0, 120)}`);
        }
      }
    })
    .catch((err) => {
      console.error('Cart fetch error', err);
      return null;
    });
}

  function getShippingConfig() {
    const block = document.querySelector('.cart-checkout-block');
    const thresh = parseInt(block?.dataset?.shipThreshold || '3500', 10);
    const base = parseInt(block?.dataset?.shipBaseCost || '495', 10);
    return { thresh: thresh > 0 ? thresh : 3500, base: base >= 0 ? base : 495 };
  }

  function computeShipping(subtotalCents) {
    if (!subtotalCents || subtotalCents <= 0) return 0;
    const { thresh, base } = getShippingConfig();
    if (subtotalCents >= thresh) return 0;
    return base;
  }

  function formatMoneyFallback(cents) {
    const value = (cents / 100).toFixed(2).replace('.', ',');
    return value;
  }

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      try {
        return Shopify.formatMoney(
          cents,
          window.theme && theme.moneyFormat ? theme.moneyFormat : '€{{amount}}'
        );
      } catch (e) {
        console.warn('Shopify.formatMoney error, fallback gebruikt', e);
      }
    }
    return '€' + formatMoneyFallback(cents);
  }

  // "€6,95" → 695
  function parseCentsFromMoney(str) {
    if (!str) return 0;
    let s = String(str)
      .replace(/\s/g, '')
      .replace('€', '')
      .replace(/\./g, '')
      .replace(',', '.');

    const value = parseFloat(s);
    if (isNaN(value)) return 0;
    return Math.round(value * 100);
  }

  /* ---------- Reco prices: hoofdprijs = met korting ---------- */

  function updateRecoPrices(discountRatio) {
    const drawer = $('#CartDrawer');
    if (!drawer) return;

    const cards = $$('.sm-cart-reco__item', drawer);
    if (!cards.length) return;

    // Als er géén korting (meer) is → alles resetten naar originele prijs
    if (!discountRatio || discountRatio <= 0) {
      cards.forEach((card) => {
        const price = card.querySelector('.price');
        if (!price) return;

        const originalCents = price.dataset.originalCents;
        if (!originalCents) return;

        const regWrapper = price.querySelector('.price__regular');
        const saleWrapper = price.querySelector('.price__sale');
        const regEl = regWrapper && regWrapper.querySelector('.price-item--regular');
        const saleEl = saleWrapper && saleWrapper.querySelector('.price-item--sale');
        const strikeEl = saleWrapper && saleWrapper.querySelector('s.price-item--regular');

        const cents = parseInt(originalCents, 10);
        const moneyText = formatMoney(cents);

        if (regEl) regEl.textContent = moneyText;
        if (saleEl) saleEl.textContent = moneyText;
        if (strikeEl) strikeEl.textContent = '';

        if (regWrapper) regWrapper.style.display = '';
        if (saleWrapper) saleWrapper.style.display = '';

        price.classList.remove('price--on-sale');
        delete price.dataset.originalCents;
      });
      return;
    }

    // Korting actief → hoofdprijs op kaart = met korting, originele prijs doorgestreept
    cards.forEach((card) => {
      const price = card.querySelector('.price');
      if (!price) return;

      const regWrapper = price.querySelector('.price__regular');
      const saleWrapper = price.querySelector('.price__sale');

      const regEl =
        regWrapper && regWrapper.querySelector('.price-item--regular');
      const saleEl =
        saleWrapper && saleWrapper.querySelector('.price-item--sale');
      const strikeEl =
        saleWrapper && saleWrapper.querySelector('s.price-item--regular');

      if (!regEl && !saleEl) return;

      // Bepaal basisprijs (éénmalig opslaan)
      let baseCents;
      if (price.dataset.originalCents) {
        baseCents = parseInt(price.dataset.originalCents, 10);
      } else {
        const baseNode = regEl || saleEl;
        const baseText = baseNode ? baseNode.textContent : '';
        baseCents = parseCentsFromMoney(baseText);
        if (!baseCents || baseCents <= 0) return;
        price.dataset.originalCents = String(baseCents);
      }

      const discountedCents = Math.round(baseCents * (1 - discountRatio));
      if (!discountedCents || discountedCents >= baseCents) return;

      const baseMoney = formatMoney(baseCents);
      const discountMoney = formatMoney(discountedCents);

      // Toon nieuwe prijs als sale, originele prijs als doorgestreept
      if (saleEl) saleEl.textContent = discountMoney;
      if (strikeEl) strikeEl.textContent = baseMoney;

      // Verberg regular blok, laat alleen sale-lijn zien
      if (regWrapper) regWrapper.style.display = 'none';
      if (saleWrapper) saleWrapper.style.display = '';

      price.classList.add('price--on-sale');
    });
  }

  /* ---------- UI updaten ---------- */

  function updateCartUI(cart) {
    const drawer = $('#CartDrawer');
    if (!drawer || !cart) return;

    try {
      const subtotal = cart.total_price || 0;
      let original = subtotal;
      let discount = 0;

      // Originele/discount bepalen op basis van line_items
      (cart.items || []).forEach((item) => {
        const orig =
          item.original_line_price != null
            ? item.original_line_price
            : item.line_price || 0;
        const fin =
          item.final_line_price != null
            ? item.final_line_price
            : item.line_price || 0;

        const diff = orig - fin;
        if (diff > 0) {
          discount += diff;
          original += diff;
        }
      });

      // Cart-level kortingen erbij optellen
      const cartLevel = cart.cart_level_discount_applications || [];
      cartLevel.forEach((app) => {
        if (app && typeof app.total_allocated_amount === 'number') {
          discount += app.total_allocated_amount;
          original += app.total_allocated_amount;
        }
      });

      const shipping = computeShipping(subtotal);
      const displayTotal = subtotal + shipping;

      const block = drawer.querySelector('.cart-checkout-block');
      if (block) {
        block.dataset.subtotal = String(subtotal);
        block.dataset.originalSubtotal = String(original);
        block.dataset.discount = String(discount);
        block.dataset.shipping = String(shipping);
        block.dataset.displayTotal = String(displayTotal);
      }

      // Korting label bepalen
      const discountWrapper = drawer.querySelector('.cart-cost-line--discount');
      const discountValueEl = drawer.querySelector('[data-cart-discount-display]');
      const discountLabelEl = drawer.querySelector('[data-cart-discount-label]');

      let discountLabel = '';
      const firstDiscountItem = drawer.querySelector('.cart-item-discounts__item');

      if (firstDiscountItem) {
        let rawText = firstDiscountItem.textContent || '';
        rawText = rawText.trim();
        rawText = rawText.replace(/\s*\(-.*\)\s*$/, '');
        discountLabel = rawText;
      } else {
        const cartLevel2 = cart.cart_level_discount_applications || [];
        const codes = cart.discount_codes || [];

        if (cartLevel2.length > 0 && cartLevel2[0].title) {
          discountLabel = cartLevel2[0].title;
        } else if (codes.length > 0 && codes[0].code) {
          discountLabel = codes[0].code;
        }
      }

      if (discountWrapper) {
        if (discount > 0) {
          discountWrapper.style.display = '';
          if (discountLabelEl) {
            discountLabelEl.textContent = discountLabel || 'Korting';
          }
          if (discountValueEl) {
            discountValueEl.textContent = '-' + formatMoney(discount);
          }
        } else {
          discountWrapper.style.display = 'none';
        }
      }

      // Subtotaal
      const subtotalEl = drawer.querySelector('[data-cart-subtotal-display]');
      if (subtotalEl) {
        subtotalEl.textContent = formatMoney(subtotal);
      }

      // Shipping
      const shippingEl = drawer.querySelector('[data-cart-shipping-display]');
      if (shippingEl) {
        if (shipping === 0 && subtotal > 0) {
          shippingEl.textContent = 'GRATIS';
        } else {
          shippingEl.textContent = formatMoney(shipping);
        }
      }

      // Totaal in knop — altijd display_total (subtotaal + bezorgkosten).
      const totalPriceEl = drawer.querySelector('#CartDrawerTotalPrice');
      if (totalPriceEl) {
        totalPriceEl.textContent = formatMoney(displayTotal);
      }

      // Checkout-knoppen — altijd enabled, vast label.
      const checkoutButtons = $$(
        'button[name="checkout"][form="MainCartDrawer"]',
        drawer
      );
      checkoutButtons.forEach((btn) => {
        btn.disabled = false;
        btn.removeAttribute('data-min-meals-ok');
        btn.classList.add('button--primary');
        btn.classList.remove('button--secondary');

        const container = btn.querySelector('.cart-drawer__checkout-button');
        if (!container) return;

        const labelNode = container.childNodes[0];
        const dotSpan = container.querySelector('span');
        const priceNode = container.querySelector('#CartDrawerTotalPrice');

        if (labelNode && labelNode.nodeType === Node.TEXT_NODE) {
          labelNode.textContent = 'Doorgaan naar afrekenen ';
        }
        if (dotSpan) dotSpan.style.display = '';
        if (priceNode) priceNode.style.display = '';
      });

      // ---------- Recommendation prijzen bijwerken ----------
      const discountRatio =
        original > 0 && discount > 0 ? discount / original : 0;

      updateRecoPrices(discountRatio);
    } catch (e) {
      console.error('Cart cost script error', e);

      const checkoutButtons = $$(
        '#CartDrawer button[name="checkout"][form="MainCartDrawer"]'
      );
      checkoutButtons.forEach((btn) => {
        btn.disabled = false;
      });
    }
  }

  /* ---------- Triggers ---------- */

  function refreshCartUI() {
    fetchCart().then((cart) => {
      if (!cart) return;
      updateCartUI(cart);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    refreshCartUI();
  });

  document.documentElement.addEventListener('cart:updated', () => {
    refreshCartUI();
  });
})();
